<div class="container">
  <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center top-16 gap-3">
    <h4>Detalhes do Instituto Previdenciário</h4>
    
    <vivest-button variant="outline" size="md" (click)="download()">
      <vivest-icon slot="icon-right" name="download" source="feather"></vivest-icon>
      Extrato de Desligamento Previdenciário
    </vivest-button>
  </div>
  
  @if (exibicao(); as dados) {
    <p class="protocolo">Protocolo: {{ dados.protocolo }}</p>

    <div class="d-flex flex-wrap cards top-32">
      @if (dados.status === statusDocumentacaoNaoValidada) {
        <div class="card-badge">
          <span class="badge">Pendente</span>
          <vivest-card variant="elevated" [fullWidth]="true" style="--vivest-color-surface-card:#FEFAEB; --vivest-space-md: 24px;">
              <label>Documentação não validada</label>
              <p>Alguns documentos que você nos enviou não puderam ser validados.</p>
              <div class="top-16 mb-3">
                <vivest-button variant="secondary" size="md" [fullWidth]="true" (click)="openDocPage()">
                  Reenviar documentos
                </vivest-button>
              </div>
          </vivest-card>
        </div>
      } @else {
        <div>
          <vivest-card variant="elevated" [fullWidth]="true" style="--vivest-color-surface-card:#FEFAEB">
            <label>Status da solicitação</label>
            <p>{{ dados.status }}</p>
          </vivest-card>
        </div>
      }
      <div>
        <vivest-card variant="elevated" [fullWidth]="true">
          <label>Instituto Previdenciário escolhido</label>
          <p>{{ dados.opcao }}</p>
        </vivest-card>
      </div>
      <!-- <div>
        <vivest-card variant="elevated" [fullWidth]="true">
          <label>Primeira parcela em</label>
          <p>{{ dados.primeiraParcela }}</p>
        </vivest-card>
      </div> -->
    </div>

    <div class="valores-resgate top-64">
      <p>Valores do seu resgate</p>
      <table>
        <tbody>
          <tr>
            <td>Número de parcelas:</td>
            <td class="text-right">{{ dados.numeroParcelas }} Parcela(s)</td>
          </tr>
          <tr>
            <td>Valor da primeira parcela:</td>
            <td class="text-right">{{ dados.valorPrimeiraParcela }}</td>
          </tr>
          <tr>
            <td>Valor Bruto do Resgate:</td>
            <td class="text-right">{{ dados.valorBruto }}</td>
          </tr>
          <tr>
            <td>Valor do Imposto de Renda (estimado):</td>
            <td class="text-right">{{ dados.valorIR }}</td>
          </tr>
          <tr>
            <td>Valor Líquido do Resgate (estimado):</td>
            <td class="text-right"><span>{{ dados.valorLiquido }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  }
  
  <app-pdf-document
    class="top-64"
    [src]="pdfSrcTermo()"
    [textoInformativo]="textoVisualizado()"
    [tipoInformativo]="termoPendente() ? 'aviso' : 'sucesso'"
    [textoAdicional]="'Termo de adesão'"
  ></app-pdf-document>
  
  <div class="d-flex justify-content-center align-items-center buttons top-64">
    <vivest-button variant="secondary" size="md" [disabled]="cancelamentoBloqueado()" (click)="onSubmit()">
      Cancelar escolha de Instituto Online
    </vivest-button>
  </div>
</div>

<vivest-modal
    heading="Deseja cancelar a escolha do seu Instituto?"
    description="Essa ação não poderá ser desfeita"
    dismissible
    [hasIcon]="true"
    [open]="openModal()"
    (vivest-close)="closeModal()"
  >
    <img slot="icon" src="assets/images/icons/Cancel.svg" alt="" />
    <vivest-button slot="actions" variant="outline" size="md" (click)="closeModal()">Não, voltar</vivest-button>
    <vivest-button slot="actions" variant="secondary" size="md" (click)="cancelar()">Sim, cancelar</vivest-button>
  </vivest-modal>

  <vivest-modal
    heading="Não conseguimos validar a sua documentação"
    description="Alguns documentos que você nos enviou não puderam ser validados."
    dismissible
    [hasIcon]="true"
    [open]="openDocModal()"
    (vivest-close)="closeDocModal()"
    style="--vivest-modal-width: 664px"
  >
    <img slot="icon" src="assets/images/icons/Cancel.svg" alt="" />
    <vivest-button slot="actions" variant="outline" size="md" (click)="closeDocModal()">Fechar</vivest-button>
    <vivest-button slot="actions" variant="secondary" size="md" (click)="openDocPage()">Reenviar documentos</vivest-button>
  </vivest-modal>